import "clsx";
import { v as attr_class, w as ensure_array_like } from "../../chunks/index2.js";
import { p as page } from "../../chunks/index3.js";
import { a as attr } from "../../chunks/attributes.js";
import { e as escape_html } from "../../chunks/escaping.js";
import "editorjs-html";
const scrollToSection = (sectionId) => {
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (section) {
    const top = section.getBoundingClientRect().top;
    const headerHeight = document.querySelector(".header")?.getBoundingClientRect().height || 0;
    setTimeout(
      () => window.scrollBy({ top: top - headerHeight, behavior: "smooth" }),
      100
    );
  }
};
function HamburgerButton($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { menuOpen = false } = $$props;
    $$renderer2.push(`<button${attr_class("header__toggle svelte-1llvae8", void 0, { "opened": menuOpen })} type="button" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"></button>`);
  });
}
function Header($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let menuOpen = false;
    const menuItems = [
      {
        path: "/#o-kancelarii",
        label: "O kancelarii",
        onClick: () => scrollToSection("o-kancelarii"),
        external: true
      },
      { path: "/czynnosci-notarialne", label: "Czynnosci notarialne" },
      { path: "/oplaty-i-platnosci", label: "Oplaty i platnosci" },
      {
        path: "/#kontakt",
        label: "Kontakt",
        onClick: () => scrollToSection("kontakt"),
        external: true
      }
    ];
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<header class="header svelte-j1jds4"><div class="container header__container svelte-j1jds4"><div class="logo-container svelte-j1jds4"><a href="/" class="logo-link svelte-j1jds4"><img class="logo-icon svelte-j1jds4" src="/logo-icon.png" alt="WW Notariusz logo ikona"/> <img class="logo svelte-j1jds4" src="/logo.svg" alt="WW Notariusz logo"/></a></div> `);
      HamburgerButton($$renderer3, {
        get menuOpen() {
          return menuOpen;
        },
        set menuOpen($$value) {
          menuOpen = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!----> <nav${attr_class("menu svelte-j1jds4", void 0, { "show": menuOpen })}><div${attr_class("", void 0, { "show": menuOpen })} id="navbarNav"><ul class="menu__list svelte-j1jds4"><!--[-->`);
      const each_array = ensure_array_like(menuItems);
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let item = each_array[$$index];
        $$renderer3.push(`<li class="menu__list-item svelte-j1jds4"><a class="menu__link svelte-j1jds4"${attr("aria-current", page.url.pathname === item.path || page.url.hash === item.path.slice(1) ? "page" : void 0)}${attr("href", item.path)}${attr("rel", item.external ? "external" : "")}>${escape_html(item.label)}</a></li>`);
      }
      $$renderer3.push(`<!--]--></ul></div></nav></div></header>`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
  });
}
function Footer($$renderer) {
  $$renderer.push(`<footer class="footer svelte-37rvse"><div class="container footer__container svelte-37rvse"><address class="footer__address svelte-37rvse"><p class="footer__paragraph fw-bold svelte-37rvse">Kancelaria Notarialna 
                Agnieszka Wencel - Iwona Wrześniak
                Spółka Cywilna</p> <p class="footer__paragraph svelte-37rvse">ul. Krakowska 180 nr lok. A3 <br/> 52-015 Wrocław</p> <p class="footer__paragraph svelte-37rvse">+48 (71) 307 00 89 <br/> kancelaria@ww-notariusz.pl</p> <p class="footer__paragraph svelte-37rvse">NIP: 8992963822 <br/> REGON: 525621158</p></address> <div class="footer__description svelte-37rvse">Informujemy, że w ramach naszej działalności prawniczej przetwarzamy Państwa dane osobowe zgodnie z Rozporządzeniem 
            Parlamentu Europejskiego i Rady (UE) 2016/679, zwane jako <a href="/rodo" class="link">RODO</a>. Nasza <a href="/polityka-prywatnosci" class="link">Polityka Prywatności</a> zawiera szczegółowe 
            informacje dotyczące celu i podstawy prawnego przetwarzania danych osobowych, okresu ich przetwarzania oraz Państwa 
            uprawnień związanych z ochroną danych osobowych. W przypadku pytań lub wątpliwości, prosimy o kontakt.</div> <div class="footer__bottom svelte-37rvse"><a href="/" title="Kancelaria Notarialna Agnieszka Wencel Iwona Wrześniak powrót do strony głównej" class="link">Kancelaria Notarialna Agnieszka Wencel Iwona Wrześniak Spółka Cywilna</a> <br/> <span>Copyright © 2025 by Codemat Mateusz Cieślak</span></div></div></footer>`);
}
function _layout($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { children, data } = $$props;
    $$renderer2.push(`<div class="app svelte-12qhfyh">`);
    Header($$renderer2);
    $$renderer2.push(`<!----> <main class="svelte-12qhfyh">`);
    {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> `);
    children?.($$renderer2);
    $$renderer2.push(`<!----></main> `);
    Footer($$renderer2);
    $$renderer2.push(`<!----></div>`);
  });
}
export {
  _layout as default
};
